customElements.component = 'image-compare-slider';

if (!customElements.get(customElements.component)) {
  class ImageCompareSlider extends HTMLElement {
    constructor() {
      super();

      this.sliderElement = this.querySelector('.js-image-compare-slider');
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed);
      this.showArrows = this.dataset.showArrows === 'true';
      this.slidesPerViewDesktop = Number(this.dataset.slidesPerViewDesktop);
      this.loop = this.dataset.loop === 'true';
      this.draggable = this.dataset.draggable === 'true';

      this.arrowPrev = this.querySelector('.js-slide-prev');
      this.arrowNext = this.querySelector('.js-slide-next');
    }

    initializeSlider() {
      if(!this.showArrows){
        this.draggable = true;
      }

      const params = {
        slidesPerView: 1,
        loop: this.loop,
        allowTouchMove: this.draggable,
        spaceBetween: 40,
        breakpoints: {
          768: {
            slidesPerView: this.slidesPerViewDesktop,
            spaceBetween: 80,
          }
        }
      }

      if (this.showArrows) {
        params.navigation = {
          nextEl: this.arrowNext,
          prevEl: this.arrowPrev,
        }
      }

      if (this.autoplay) {
        params.autoplay = {
          delay: this.autoplaySpeed,
          disableOnInteraction: false
        }
      }

      this.slider = new Swiper(this.sliderElement, params);

      this.slider.on('slideChange', function () {
        this.slider?.navigation.update();
      });
    }

    connectedCallback() {
      this.initializeSlider();
    }

    disconnectedCallback() {
      this.slider?.destroy(true, true);
    }
  }

  customElements.define(customElements.component, ImageCompareSlider);
}